module.exports = __webpack_public_path__ + "img/P2-B4.b2eedef8.svg";